import { cn } from '@/shared/lib/cn';

import { Icon, type IconName } from './Icon';
import { chipTone, type ToneName } from './tones';

type ChipSize = 'sm' | 'md' | 'lg';

const sizes: Record<ChipSize, { box: string; icon: number }> = {
  sm: { box: 'size-8 rounded-lg', icon: 16 },
  md: { box: 'size-10 rounded-xl', icon: 19 },
  lg: { box: 'size-12 rounded-2xl', icon: 22 },
};

/**
 * Icone dentro de um chip colorido pelo sentido (`tones.ts`): o mesmo desenho no
 * indicador do painel, na esteira e no estado vazio. E decoracao: o texto ao lado
 * diz o que o icone mostra, e por isso o chip fica fora do leitor de tela.
 */
export function IconChip({
  icon,
  tone = 'brand',
  size = 'md',
  className,
}: {
  icon: IconName;
  tone?: ToneName | undefined;
  size?: ChipSize | undefined;
  className?: string | undefined;
}) {
  const medida = sizes[size];
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center bg-linear-to-br',
        'shadow-(--shadow-xs) ring-1 ring-inset',
        'transition-transform duration-(--duration-base) ease-(--ease-out-soft)',
        medida.box,
        chipTone[tone],
        className,
      )}
    >
      <Icon name={icon} size={medida.icon} />
    </span>
  );
}
